import Generator from '../../../../Generator'
import Types from '../../../../../actions/Types'

export default Generator.node({
  baseType: Types.CTRL_GROUPS,
  nodeType: Generator.NODETYPE.PUT
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/controls/group/put.js